import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

function AdminOrPermissionRoute({ children, permission }) {
	const { user, loading, isAdmin } = useAuth();

	if (loading) {
		return <div className="loading-container">Loading...</div>;
	}

	// Allow if admin or has required permission
	if (user && (isAdmin() || user.permissions?.includes(permission))) {
		return children;
	}

	// Redirect to dashboard
	return <Navigate to="/" replace />;
}

export default AdminOrPermissionRoute;
